import CiviliteSelect from "./CiviliteSelect";
import PaysAutocomplete from "./PaysAutocomplete";
import NationaliteAutocomplete from "./NationaliteAutocomplete";
import CommuneAutocomplete from "./CommuneAutocomplete";
import CommuneCombobox from "./CommuneCombobox";
import TypeDocumentSelect from "./TypeDocumentSelect";
import GouvernanceCombobox from "./GouvernanceCombobox";
import FonctionCombobox from "./FonctionCombobox";
import LienCombobox from "./LienCombobox";
import DomaineSelect from "./DomaineSelect";
import ThemeSelect from "./ThemeSelect";
import FormeJuridiqueCombobox from "./FormeJuridiqueCombobox";
import ButAssociationSwitch from "./ButAssociationSwitch";
import CooperativeSelect from "./CooperativeSelect";
import TypeAssembleGeneraleSelect from "./TypeAssembleGeneraleSelect";
import DureeField from "./DureeField";
import DureeSelect from "./DureeSelect";
import JournalAnnonceCombobox from "./JournalAnnonceCombobox";

export default {
    install(Vue) {
        Vue.component("a-commune-autocomplete", CommuneAutocomplete);
        Vue.component("a-commune-combobox", CommuneCombobox);
        Vue.component("a-pays-autocomplete", PaysAutocomplete);
        Vue.component("a-nationalite-autocomplete", NationaliteAutocomplete);
        Vue.component("a-civilite-select", CiviliteSelect);
        Vue.component("a-gouvernance-combobox", GouvernanceCombobox);
        Vue.component("a-fonction-combobox", FonctionCombobox);
        Vue.component("a-lien-combobox", LienCombobox);
        Vue.component("a-domaine-select", DomaineSelect);
        Vue.component("a-theme-select", ThemeSelect);
        Vue.component("a-forme-juridique-combobox", FormeJuridiqueCombobox);
        Vue.component("a-type-document-select", TypeDocumentSelect);
        Vue.component("a-but-association-switch", ButAssociationSwitch);
        Vue.component("a-cooperative-select", CooperativeSelect);
        Vue.component("a-type-assemble-generale-select", TypeAssembleGeneraleSelect);
        Vue.component("a-duree-field", DureeField);
        Vue.component("a-duree-select", DureeSelect);
        Vue.component("a-journal-annonce-combobox", JournalAnnonceCombobox);
    }
}
